import { Button } from '@ksyos/design-system';
import { useState } from 'react';
import type { IServiceRights } from './ServiceRightStopModal';
import { translateKey } from '../../../../translate';
import { ServiceRightStopModal } from './ServiceRightStopModal';

interface IStopServiceGroupLinkProps extends IServiceRights {
    organizationId: string;
    serviceGroupName: string;
}

export function StopServiceGroupLink(props: IStopServiceGroupLinkProps) {
    const [showStopServiceGroupModal, setShowStopServiceGroupModal] = useState(false);

    return (
        <>
            <Button
                onClick={() => setShowStopServiceGroupModal(true)}
                variant="link"
            >
                {translateKey('carePath.stopServiceGroup', props.serviceGroupName)}
            </Button>
            {showStopServiceGroupModal && (
                <ServiceRightStopModal
                    {...props}
                    alertMessage={translateKey('serviceRightStopModal.warningServiceGroup', props.serviceGroupName)}
                    bodyText={translateKey('serviceRightStopModal.bodyServiceGroup', props.serviceGroupName)}
                    endDate={new Date()}
                    onClose={() => setShowStopServiceGroupModal(false)}
                    stopServiceGroup={true}
                    title={translateKey('serviceRightStopModal.titleServiceGroup', props.serviceGroupName)}
                />
            )}
        </>
    );
}
